<template>
  <a-spin tip="加载中..." :spinning="spinning">
    <a-card v-if="open_repair_service==='YES'" :bordered="false">
      <!-- 表格筛选 start -->
      <a-form layout="inline" @submit="handleSubmit">
        <a-form-item>
          <!-- 关键字搜索 -->
          <a-input v-model="queryParam.keyWord" placeholder="请输入关键字" allowClear>
            <!-- 选择搜索类型 -->
            <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
              <a-select-option :value="item.id" :key="item.id" v-for="item in searchTypeDict">{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <!-- 创建时间 -->
        <a-form-item>
          <a-range-picker :value="time" showTime format="YYYY-MM-DD" @change="onChangeTime"/>
        </a-form-item>
        <a-form-item>
          <a-input-group compact style="width: 360px">
            <a-input placeholder="产品" disabled style="width: 60px;text-align: center;" />
            <a-select v-model="queryParam.goods_id" placeholder="请选择" style="width:200px">
              <a-select-option value="">请选择</a-select-option>
              <a-select-option :value="item.id" :key="item.id" v-for="item in dict.goods_list">{{ item.name }}</a-select-option>
            </a-select>
          </a-input-group>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit">查询</a-button>
          <a-button style="margin-left: 8px" @click="reset">重置</a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        style="margin-top:40px;"
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        bordered
      >
        <span slot="contact" slot-scope="text, record">
          <span>{{ record.nickname }}</span><br />
          <span>{{ record.phone }}</span>
        </span>
        <span slot="content" slot-scope="text, record">
          <span>{{ record.content }}</span> <a @click="openVoucher(record)" style="margin-left:15px;">凭证<a-icon style="font-size:18px;margin-left:5px;" type="search" /></a>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <span v-if="!isEdit">{{ record.remark }}</span>
            <a-input v-if="isEdit && editItem.repair_order_id === record.repair_order_id" v-model="editItem.remark" placeholder="请输入备注" allowClear />
            <a v-if="!isEdit" @click="editRemark(record)"><a-icon style="font-size:18px;margin-left:5px;" type="edit" /></a>
            <a v-if="isEdit" @click="postEdit()">保存</a>
          </template>
        </span>
      </tcg-table>
      <!-- 表格 end -->
      <!-- 凭证查看弹出 -->
      <a-modal
        width="500px"
        title="凭证查看"
        v-if="viewVisible"
        :visible="viewVisible"
        :footer="null"
        @cancel="viewVisible = false"
      >
        <div style="width:100%;height:350px;">
          <div style="width:120px;float:left;margin-bottom:30px;margin-top:20px;margin-left:20px;" v-for="(voucher,index) in voucherList" :key="index">
            <img v-if="voucher.type=='PIC'" :src="voucher.url" style="width:120px;height:120px;border:1px solid #fff;margin:0 auto;" @click="handlePreviewPic(voucher.url,'PIC')"/>
            <video v-if="voucher.type=='VIDEO'" :src="voucher.url" style="width:120px;height:120px;border:1px solid #fff;margin:0 auto;" @click="handlePreviewPic(voucher.url,'VIDEO')"/>
          </div>
        </div>
      </a-modal>
      <!-- 查看大图 -->
      <a-modal
        :zIndex="1001"
        :visible="previewVisible"
        :footer="null"
        @cancel="previewVisible = false"
        :width="500"
      >
        <img
          v-if="previewType === 'PIC'"
          alt="example"
          style="width:100%; margin-top:30px"
          :src="previewImage"
        />
        <video
          v-if="previewType === 'VIDEO'"
          :src="previewImage"
          :controls="videoOptions.controls"
          class="video-js vjs-big-play-centered vjs-fluid"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="allow"
          x5-playsinline
          autoplay="autoplay"
          ref="video"
          style="width:100%; margin-top:30px"/>
      </a-modal>
    </a-card>
    <a-result v-else status="403" title="报修服务暂未开通" sub-title="无法使用，请联系业务经理进行升级"/>
  </a-spin>
</template>
<script>
import { checkService } from '@/api/maintain'
import { getPre, getList, remark } from '@/api/repair'
import { TcgTable } from '@/components'
import { downloadFile } from '@/utils'
import _ from 'lodash'

const searchTypeDict = [
  {
    id: 'repair_orderId',
    name: '报修单号'
  },
  {
    id: 'sale_record_id',
    name: '云码ID'
  },
  {
    id: 'phone',
    name: '手机号码'
  },
  {
    id: 'remark',
    name: '备注'
  },
  {
    id: 'uid',
    name: '用户ID'
  },
  {
    id: 'brand_id',
    name: '品牌ID'
  }
]
export default {
  components: {
    TcgTable
    // viewDrawer
  },
  data () {
    return {
      spinning: true, // 页面加载。。
      open_repair_service: 'YES',
      videoOptions: {
        controls: true
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // phoneVisible: false,
      // id
      id: '',
      // 关键字搜索类型列表
      searchTypeDict,
      // 字典
      dict: {
        goods_list: []
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keyWordType: 'repair_orderId',
        keyWord: '',
        start_time: '',
        end_time: '',
        goods_id: ''
      },
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '报修单号',
          dataIndex: 'repair_orderId',
          width: '150px'
        },
        {
          title: '品牌ID',
          dataIndex: 'brand_id'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name'
        },
        {
          title: '云码ID',
          dataIndex: 'sale_record_id',
          width: '80px'
        },
        {
          title: '云码',
          dataIndex: 'code',
          width: '120px'
        },
        {
          title: '申请时间',
          dataIndex: 'create_time',
          width: '100px'
        },
        {
          title: '用户',
          dataIndex: 'user',
          width: '80px'
        },
        {
          title: '产品',
          dataIndex: 'goods_name',
          width: '150px'
        },
        {
          title: '保修期限',
          dataIndex: 'maintain_expire_time',
          width: '120px'
        },
        {
          title: '报修详情',
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' },
          width: '200px'
        },
        {
          title: '地址',
          dataIndex: 'rep_address',
          width: '150px'
        },
        {
          title: '联系人信息',
          dataIndex: 'contact',
          scopedSlots: { customRender: 'contact' },
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '100px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      editItem: {},
      isEdit: false,
      voucherList: [],
      countDown: 0,
      codeText: '获取验证码',
      previewVisible: false,
      previewImage: '',
      previewType: ''
    }
  },
  created () {
    this.checkService()
    this.handelPre()
    // 查询用户
    if (this.$route.query.uid) {
      this.queryParam.keyWord = this.$route.query.uid
      this.queryParam.keyWordType = 'uid'
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    }
  },
  methods: {
    // 导出
    handleExport() {
      const href = window.location.origin + '/merchant.php/repair/outExcel'
      downloadFile(href)
    },
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'data', {})
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        keyWordType: 'repair_orderId',
        keyWord: '',
        start_time: '',
        end_time: '',
        goods_id: ''
      }
      this.time = []
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 选择时间事件
    onChangeTime (dateStrings) {
      this.time = dateStrings
      if (dateStrings.length !== 0) {
        this.queryParam.start_time = dateStrings[0].format('YYYY-MM-DD')
        this.queryParam.end_time = dateStrings[1].format('YYYY-MM-DD')
      } else {
        this.queryParam.start_time = ''
        this.queryParam.end_time = ''
      }
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 开启更多查询方式
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    editRemark (record) {
      this.editItem = {
        repair_order_id: record.repair_order_id,
        remark: record.remark
      }
      this.isEdit = true
    },
    // 编辑
    postEdit() {
      remark(this.editItem)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('备注成功')
            this.editItem = {}
            this.isEdit = false
            this.$refs.table.refresh(true)
          }
        })
        .catch((e) => {
          this.$message.error('备注失败')
        })
    },
    openVoucher (record) {
      this.voucherList = record.voucher
      this.viewVisible = true
    },
    // 预览图片
    handlePreviewPic(pic, type) {
      this.previewImage = pic
      this.previewType = type
      this.previewVisible = true
    },
    // 检查服务
    checkService() {
      this.spinning = true
      checkService()
        .then((res) => {
          if (res.code === 200) {
            this.open_repair_service = res.data.open_repair_service
          } else {
            this.$message.error('检查服务失败')
          }
        })
        .catch((e) => {
          this.$message.error('检查服务失败')
        })
        .finally(() => {
          this.spinning = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
